/*
 * @Author: xiangheng
 * @Date: 2019-07-30 17:37:06
 * @LastEditors: xiangheng
 * @LastEditTime: 2019-09-20 16:20:22
 * @Description: file content
 */
/**
 * 时间戳转日期格式
 * @param date 时间
 * @param type 时间类型 yyyy-MM-dd HH:mm:ss ww
 * return string
 */
export function FormatDate (date, type) {
  if (!date) return ''
  date = typeof date === 'number' ? new Date(date) : date
  type = type || 'yyyy-MM-dd HH:mm:ss'
  let obj = {
    'y': date.getFullYear(), // 年份，注意必须用getFullYear
    'M': date.getMonth() + 1, // 月份，注意是从0-11
    'd': date.getDate(), // 日期
    'q': Math.floor((date.getMonth() + 3) / 3), // 季度
    'w': date.getDay(), // 星期，注意是0-6
    'H': date.getHours(), // 24小时制
    'h': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 12小时制
    'm': date.getMinutes(), // 分钟
    's': date.getSeconds(), // 秒
    'S': date.getMilliseconds() // 毫秒
  }
  let week = ['天', '一', '二', '三', '四', '五', '六']
  for (let i in obj) {
    type = type.replace(new RegExp(i + '+', 'g'), function (m) {
      let val = obj[i] + ''
      if (i === 'w') return (m.length > 2 ? '星期' : '周') + week[val]
      for (let j = 0, len = val.length; j < m.length - len; j++) val = '0' + val
      return m.length === 1 ? val : val.substring(val.length - m.length)
    })
  }
  return type
}

export function iframeDownload(downUrl, cb) {
  const prefix = process.env.NODE_ENV === 'development' ? '/api' : ''
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = encodeURI(prefix + downUrl)
  document.body.appendChild(iframe)
  setTimeout(
    function () {
      this.remove()
    }.bind(iframe),
    500000
  )
  if (!cb) return // 后端返回json，如{"data":null,"errorCode":-1,"errorMessage":"开始时间和结束时间不能同为空"}    李可政 add                                 
  iframe.onload = () => {
    const iframeWin = iframe.contentWindow.document.body.innerText // 拿到iframe 的window对象
    if (iframeWin.indexOf('errorMessage') !== -1 || iframeWin.indexOf('msg') !== -1) { // window.document.body.innerText获取页面上的纯文本
      const obj = JSON.parse(iframeWin)
      cb(obj.errorMessage || obj.msg || '未知错误')
    }
  }
}

export function getUploadHost(url) {
  const { hostname } = window.location
  const y = hostname.split('.')[0]
  const config = {
    t: 'https://cdn-do-dev.yunjiglobal.com', // 阿里云
    txst: 'https://cdn-txst.yunjiglobal.com', // 腾讯云
    y: 'https://cdn-do-dev.yunjiglobal.com', // 本地 根据代理的环境切换
    'customerserviceadmin-do-dev': 'https://cdn-do-dev.yunjiglobal.com',
    't-do-dev': 'https://cdn-do-dev.yunjiglobal.com'
  }
  const host = config[y] || 'https://cdn.yunjiglobal.com' // 都不满足则是现网
  url = `${host}${url}`
  return url
}

export function creaHtml(html) {
  let text = ''
  if (html) {
    const oDiv = document.createElement('div')
    oDiv.innerHTML = html
    text = oDiv.innerText
  }
  return text
}

export function getTreeData(data) {
  data.forEach((v) => {
    if (v.children.length < 1) {
      // children若为空数组，则将children设为undefined
      v.children = undefined
    } else {
      // children若不为空数组，则继续 递归调用 本方法
      getTreeData(v.children)
    }
  })
  return data
}
